(ns practitest.frontend.components2.dashboard.tab-events
  "Dashboard tab requests and New/Edit tab modal state, shared by the Dashboard Tab List and Summary pages.
   Request events take the page's `:on-success` / `:on-failure` handlers, since each page updates its own state.
   Modal events take the page's `db-key`; the modal state lives under `[db-key :edit-modal]`."
  (:require [ajax.core :as ajax]
            [re-frame.core :as re-frame]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]))

(defn error-message
  "The server's error message from a failed request's `response`, or a generic one."
  [response]
  (or (get-in response [:response :message])
      (get-translation "generic.error.general" "Something went wrong. Please try again.")))

;; Single-tab actions: same request shape, differing only in HTTP method and route
(def ^:private tab-actions
  {::clone-tab      [:post   "dashboards#clone"]
   ::archive-tab    [:put    "dashboards#archive"]
   ::unarchive-tab  [:put    "dashboards#unarchive"]
   ::delete-tab     [:delete "dashboards#destroy"]
   ::regenerate-key [:post   "dashboards#regenerate_key"]})

(doseq [[event-id [method route]] tab-actions]
  (re-frame/reg-event-fx
   event-id
   (fn [{:keys [db]} [_ tab-id {:keys [on-success on-failure]}]]
     {:http-xhrio {:method          method
                   :uri             (broutes/get-url route
                                                     {:p_id (subs/get-current-project-id db) :id tab-id}
                                                     {:format "json"})
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      on-success
                   :on-failure      on-failure}})))

(re-frame/reg-event-db
 ::open-edit-modal
 (fn [db [_ db-key tab-id]]
   (assoc-in db [db-key :edit-modal] {:tab-id tab-id})))

(re-frame/reg-event-db
 ::open-new-modal
 (fn [db [_ db-key]]
   (assoc-in db [db-key :edit-modal] {:new? true})))

(re-frame/reg-event-db
 ::close-edit-modal
 (fn [db [_ db-key]]
   (update db db-key dissoc :edit-modal)))

;; Failures stay in the modal: shown as its error, and the form can be saved again
(re-frame/reg-event-db
 ::save-tab-failed
 (fn [db [_ db-key response]]
   (update-in db [db-key :edit-modal] assoc
              :saving? false
              :error (error-message response))))

(re-frame/reg-event-fx
 ::save-tab
 (fn [{:keys [db]} [_ db-key tab-id form on-success]]
   {:db         (update-in db [db-key :edit-modal] assoc :saving? true :error nil)
    :http-xhrio {:method          :put
                 :uri             (broutes/get-url "dashboards#update"
                                                   {:p_id (subs/get-current-project-id db) :id tab-id}
                                                   {:format "json"})
                 :params          form
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      on-success
                 :on-failure      [::save-tab-failed db-key]}}))

(re-frame/reg-event-fx
 ::create-tab
 (fn [{:keys [db]} [_ db-key form on-success]]
   {:db         (update-in db [db-key :edit-modal] assoc :saving? true :error nil)
    :http-xhrio {:method          :post
                 :uri             (broutes/get-url "dashboards#create"
                                                   {:p_id (subs/get-current-project-id db)}
                                                   {:format "json"})
                 :params          form
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success      on-success
                 :on-failure      [::save-tab-failed db-key]}}))
